export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "same_neutral": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Same"])},
        "same_masculine": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Same"])},
        "same_feminine": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Same"])},
        "same_neuter": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Same"])},
        "DATING": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Date"])},
        "PERSON": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Artists/Producer"])},
        "THEME": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Theme"])},
        "DISTRICT": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["District"])},
        "CLASSIFICATION": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Classification"])},
        "CLOCK_DRIVE": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Power Source"])},
        "ICONCLASS": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Subject"])},
        "MATERIAL": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Material"])},
        "TECHNIQUE": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Technique"])},
        "PLACE": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Place"])},
        "COIN_MINT": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mint"])},
        "COIN_TERRITORY": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mint Territory"])}
      },
      "de": {
        "same_neutral": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gleiche/r"])},
        "same_masculine": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gleicher"])},
        "same_feminine": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gleiche"])},
        "same_neuter": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gleiches"])},
        "DATING": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datierung"])},
        "PERSON": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Künstler:in/Hersteller:in"])},
        "THEME": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Thema"])},
        "DISTRICT": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bezirk"])},
        "CLASSIFICATION": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Objektart"])},
        "CLOCK_DRIVE": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Antriebsart"])},
        "ICONCLASS": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bildmotiv"])},
        "MATERIAL": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Material"])},
        "TECHNIQUE": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Technik"])},
        "PLACE": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ort"])},
        "COIN_MINT": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Münzstätte"])},
        "COIN_TERRITORY": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Münzstand"])}
      }
    }
  })
}
